import { Accents, Component, Knobs, Story } from './DocTypes';

const CarouselKnobs: Knobs = {
  dotsAccent: {
    default: 'access',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
};

const CarouselKnobsV3: Knobs = {
  ...CarouselKnobs,
  colourScheme: {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', 'default', ''],
    default: '',
  },
};

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'A simple carousel',
  coreComponent: {
    html: `
    <tag-card version='2' accent='access' background-image='access'>
        <div style="padding: 20px; text-align: center;">
            <tag-carousel{{...knobs}}>
                <tag-carousel-slide style="padding: 50px">First slide</tag-carousel-slide>
                <tag-carousel-slide style="padding: 50px">Second slide</tag-carousel-slide>
                <tag-carousel-slide style="padding: 50px">Third slide</tag-carousel-slide>
            </tag-carousel>
        </div>
    </tag-card>`,
    knobs: CarouselKnobs,
  },
  coreComponent_v3: {
    html: `
    <tag3-card accent='access' background-image='access'>
        <div style="padding: 20px; text-align: center;">
            <tag3-carousel{{...knobs}}>
                <tag3-carousel-slide style="padding: 50px">First slide</tag3-carousel-slide>
                <tag3-carousel-slide style="padding: 50px">Second slide</tag3-carousel-slide>
                <tag3-carousel-slide style="padding: 50px">Third slide</tag3-carousel-slide>
            </tag3-carousel>
        </div>
    <tag3-card>
    `,
    knobs: CarouselKnobsV3,
  },
  reactWrapper: {
    jsx: `
    <TagCard version='2' accent='access' background-image='access'>
        <div style={{padding: '20px', textAlign: 'center'}}>
            <TagCarousel{{...knobs}}>
                <TagCarouselSlide style={{padding: '50px'}}>First slide</TagCarouselSlide>
                <TagCarouselSlide style={{padding: '50px'}}>Second slide</TagCarouselSlide>
                <TagCarouselSlide style={{padding: '50px'}}>Third slide</TagCarouselSlide>
            </TagCarousel>
        </div>
    </TagCard>`,
    knobs: CarouselKnobs,
  },
  reactWrapper_v3: {
    jsx: `
    <Tag3Card accent='access' background-image='access'>
        <div style={{padding: '20px', textAlign: 'center'}}>
            <Tag3Carousel{{...knobs}}>
                <Tag3CarouselSlide style={{padding: '50px'}}>First slide</Tag3CarouselSlide>
                <Tag3CarouselSlide style={{padding: '50px'}}>Second slide</Tag3CarouselSlide>
                <Tag3CarouselSlide style={{padding: '50px'}}>Third slide</Tag3CarouselSlide>
            </Tag3Carousel>
        </div>
    </Tag3Card>`,
    knobs: CarouselKnobsV3,
  },
};

const StatsStory: Story = {
  title: 'Carousel with stats',
  description: 'A KPI card with the stats in a carousel',
  coreComponent: {
    html: `<tag-card version='2' accent='access' background-image='access'>
    <tag-app-header icon='BarChart2' heading='KPIs' heading-accent='white'></tag-app-header>
    <div style="padding: 10px 0px;">
      <tag-carousel{{...knobs}}>
          <tag-carousel-slide>
            <tag-stats>
              <tag-stats-data value="21" label="Outstanding Orders"></tag-stats-data>
              <tag-stats-data value="£66,040.98" label="Order Value"></tag-stats-data>
            </tag-stats>
          </tag-carousel-slide>
          <tag-carousel-slide>
          <tag-stats>
            <tag-stats-data value="10" label="Outstanding Calls"></tag-stats-data>
            <tag-stats-data value="2.3 hrs" label="Average Wait"></tag-stats-data>
          </tag-stats>
          </tag-carousel-slide>
          <tag-carousel-slide>
          <tag-stats>
            <tag-stats-data value="4" label="Leads"></tag-stats-data>
            <tag-stats-data value="£14.7K" label="Lead Value"></tag-stats-data>
          </tag-stats>
          </tag-carousel-slide>
      </tag-carousel>
    </div>
  </tag-card>`,
    knobs: CarouselKnobs,
  },
  coreComponent_v3: {
    html: `<tag3-card accent='access' background-image='access'>
    <tag3-app-header icon='BarChart2' icon-accent='access' heading='KPIs' heading-accent='white'></tag3-app-header>
    <div style="padding: 10px 0px;">
      <tag3-carousel{{...knobs}}>
          <tag3-carousel-slide>
            <tag3-stats>
              <tag3-stats-data value="21" label="Outstanding Orders"></tag3-stats-data>
              <tag3-stats-data value="£66,040.98" label="Order Value"></tag3-stats-data>
            </tag3-stats>
          </tag3-carousel-slide>
          <tag3-carousel-slide>
          <tag3-stats>
            <tag3-stats-data value="10" label="Outstanding Calls"></tag3-stats-data>
            <tag3-stats-data value="2.3 hrs" label="Average Wait"></tag3-stats-data>
          </tag3-stats>
          </tag3-carousel-slide>
          <tag3-carousel-slide>
          <tag3-stats>
            <tag3-stats-data value="4" label="Leads"></tag3-stats-data>
            <tag3-stats-data value="£14.7K" label="Lead Value"></tag3-stats-data>
          </tag3-stats>
          </tag3-carousel-slide>
      </tag3-carousel>
    </div>
  </tag3-card>`,
    knobs: CarouselKnobsV3,
  },
  reactWrapper: {
    jsx: `<TagCard version='2' accent='access' backgroundImage='access'>
  <TagAppHeader icon='BarChart2' heading='KPIs' headingAccent='white' />
  <div style={{padding: '10px 0px'}}>
    <TagCarousel{{...knobs}}>
      <TagCarouselSlide>
        <TagStats
          data={[
            { label: 'Outstanding Orders', value: '21' },
            { label: 'Order Value', value: '£66,040.98' },
          ]}
          labelField="label"
          valueField="value"
        />
      </TagCarouselSlide>
      <TagCarouselSlide>
        <TagStats
          data={[
            { label: 'Outstanding Calls', value: '10' },
            { label: 'Average Wait', value: '2.3 hrs' },
          ]}
          labelField="label"
          valueField="value"
        />
      </TagCarouselSlide>
      <TagCarouselSlide>
        <TagStats
          data={[
            { label: 'Leads', value: '4' },
            { label: 'Lead Value', value: '£14.7K' },
          ]}
          labelField="label"
          valueField="value"
        />
      </TagCarouselSlide>
    </TagCarousel>
  </div>
</TagCard>`,
    knobs: CarouselKnobs,
  },
  reactWrapper_v3: {
    jsx: `<Tag3Card version='2' accent='access' backgroundImage='access'>
  <Tag3AppHeader icon='BarChart2' icon-accent='access' heading='KPIs' headingAccent='white' />
  <div style={{padding: '10px 0px'}}>
    <Tag3Carousel{{...knobs}}>
      <Tag3CarouselSlide>
        <Tag3Stats
          data={[
            { label: 'Outstanding Orders', value: '21' },
            { label: 'Order Value', value: '£66,040.98' },
          ]}
          labelField="label"
          valueField="value"
        />
      </Tag3CarouselSlide>
      <Tag3CarouselSlide>
        <Tag3Stats
          data={[
            { label: 'Outstanding Calls', value: '10' },
            { label: 'Average Wait', value: '2.3 hrs' },
          ]}
          labelField="label"
          valueField="value"
        />
      </Tag3CarouselSlide>
      <Tag3CarouselSlide>
        <Tag3Stats
          data={[
            { label: 'Leads', value: '4' },
            { label: 'Lead Value', value: '£14.7K' },
          ]}
          labelField="label"
          valueField="value"
        />
      </Tag3CarouselSlide>
    </Tag3Carousel>
  </div>
</Tag3Card>`,
    knobs: CarouselKnobsV3,
  },
};

export const TagCarouselSlideDocs: Component = {
  type: 'component',
  name: 'carousel-slide',
  description: 'Render a slide from carousel',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [],
  reactPropOverrides: [],
  events: [],
  methods: [],
  stories: [],
};

export const TagCarouselDocs: Component = {
  type: 'component',
  name: 'carousel',
  description: 'Renders a collection of carousel slides',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'dotsAccent',
      default: '',
      description: 'The dots colour',
      type: 'string',
    },
    {
      name: 'colourScheme',
      description:
        'V3 Only: Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'light',
    },
  ],
  reactPropOverrides: [],
  events: [],
  methods: [],
  stories: [PlaygroundStory, StatsStory],
  childComponents: [TagCarouselSlideDocs],
};
